import * as React from 'react';
import './customautosuggest.css'
import RiotDB from "../../fbobjects/RiotDB";
import Autosuggest = require("react-autosuggest");

interface CustomAutoSuggestProps {
    onChoose:(string)=>void;
    suggestions: string[];
    type:string;
    defaultValue:string;
    onBlur:()=>void;
}

export default class CustomAutosuggest extends React.Component<CustomAutoSuggestProps,any> {

    constructor(props: CustomAutoSuggestProps){
        super(props);
        this.state = {
            value:"",
            suggestions:[]
        }
    }

    onSuggestionsFetchRequested = ({ value }) => {

        let check:string = value.trim().toUpperCase();

        let suggestions = this.props.suggestions.filter((name:string)=>{
            return name.toUpperCase().indexOf(check) != -1;
        });

        this.setState({
            suggestions: suggestions
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };

    onSuggestionSelected = (event,  { suggestion }) => {
        this.props.onChoose(suggestion);
    };

    renderDefaultValue(){
        if (this.props.defaultValue == "" || this.props.defaultValue == null){
            return "Search"
        }
        return this.props.defaultValue;
    }

    onBlur = (event, { highlightedSuggestion }) => {
        if (highlightedSuggestion != null){
            this.props.onChoose(highlightedSuggestion);

        }
        this.props.onBlur();
    };

    renderHeaderType(){
        if (this.props.type == "item"){
            return "item-header"
        }
        return "champ-header";
    }

    render() {
        const inputProps = {
            placeholder: this.renderDefaultValue(),
            value:this.state.value,
            onChange: this.onChange,
            autoFocus: true,
            onBlur: this.onBlur,
        };

        return (
            <div className={this.renderHeaderType()}>


                <Autosuggest
                    suggestions={this.state.suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={value => value}
                    renderSuggestion={value=><div>{value}</div>}
                    onSuggestionSelected={this.onSuggestionSelected}
                    inputProps={inputProps}
                />

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/CustomAutosuggest/index.tsx